/*
*   List of Actions with TYPE that should be passed from accreditation.reducer.js to scheme.reducer.js
 */

export const PREFIX = 'ACCREDITATION';

export const TYPES = {
    FETCH_SECTIONS_TREE_PROGRESS:       `${PREFIX}_FETCH_SECTIONS_TREE_PROGRESS`,
    SELECT_REQUIREMENT:                 `${PREFIX}_SELECT_SECTION`,
    FETCH_SITE_LOCATION_DETAILS:        `${PREFIX}_FETCH_SITE_LOCATION_DETAILS`,
    FETCH_SCHEME_ENABLED_HEAD_OFFICES:  `${PREFIX}_FETCH_SCHEME_ENABLED_HEAD_OFFICES`,
    FETCH_SCHEME_ENABLED_SITE_LOCATIONS:`${PREFIX}_FETCH_HOF_ENABLED_SITE_LOCATIONS`,
    SELECT_ASSESSMENT_ITEM:             `${PREFIX}_SELECT_ASSESSMENT_ITEM`,
    LOCATION_SEARCH_BAR_CHANGE:         `${PREFIX}_LOCATION_SEARCH_BAR_CHANGE`,
    SCHEME_SECTIONS_RESET:              `${PREFIX}_SCHEME_SECTIONS_RESET`,
    SECTIONS_TREE_UNSELECT_ALL:         `${PREFIX}_SECTIONS_TREE_UNSELECT_ALL`,
    SIMPLE_STD_TREE_UNSELECT_ALL:       `${PREFIX}_SIMPLE_STD_TREE_UNSELECT_ALL`,
    SIMPLE_STD_TREE_SELECT:             `${PREFIX}_SIMPLE_STD_TREE_SELECT`,
    FETCH_REQUIREMENTS_TREE:            `${PREFIX}_FETCH_REQUIREMENTS_TREE`,
    FETCH_AUTOCO_EMPLOYEES_AND_MANAGERS:`${PREFIX}_FETCH_AUTOCO_EMPLOYEES_AND_MANAGERS`,
    FETCH_AUTOCOMPLETE_USER_DETAILS:    `${PREFIX}_FETCH_AUTOCOMPLETE_USER_DETAILS`,
};
